import { ComponentType, RedirectTarget } from '@wix/ambassador-devcenter-appsruntimereader-v1-app-runtime-data/types';
export const getAppName = app => (app == null ? void 0 : app.name) || '';
export const getAppUri = appRuntimeData => {
  var _appRuntimeData$appIn;
  return (appRuntimeData == null || (_appRuntimeData$appIn = appRuntimeData.appInstallationData) == null || (_appRuntimeData$appIn = _appRuntimeData$appIn.appUrl) == null ? void 0 : _appRuntimeData$appIn.appUri) || null;
};
export const getIsAdvanceOauthApp = appRuntimeData => {
  var _appRuntimeData$appIn2;
  return !!(appRuntimeData != null && (_appRuntimeData$appIn2 = appRuntimeData.appInstallationData) != null && (_appRuntimeData$appIn2 = _appRuntimeData$appIn2.appUrl) != null && _appRuntimeData$appIn2.appUri);
};
export const getAppRedirectUrls = appRuntimeData => {
  var _appRuntimeData$appIn3;
  return (appRuntimeData == null || (_appRuntimeData$appIn3 = appRuntimeData.appInstallationData) == null || (_appRuntimeData$appIn3 = _appRuntimeData$appIn3.appUrl) == null ? void 0 : _appRuntimeData$appIn3.redirectUris) || [];
};
export const getAppPermissions = appRuntimeData => {
  var _appRuntimeData$appIn4;
  return (appRuntimeData == null || (_appRuntimeData$appIn4 = appRuntimeData.appInstallationData) == null ? void 0 : _appRuntimeData$appIn4.permissions) || [];
};
export const isExternalDashboardApp = appRuntimeData => {
  const {
    components,
    appInstallationData
  } = appRuntimeData || {};
  const {
    postInstallationComponentId,
    overridePostInstallationRedirect
  } = appInstallationData || {};
  const externalDashboardComponent = components == null ? void 0 : components.find(comp => {
    var _comp$data;
    return comp.type === ComponentType.DASHBOARD && ((_comp$data = comp.data) == null || (_comp$data = _comp$data.dashboardComponentData) == null ? void 0 : _comp$data.embedded) === false;
  });
  const withEditorPostInstallationOverride = overridePostInstallationRedirect === RedirectTarget.EDITOR;
  return Boolean(externalDashboardComponent && (externalDashboardComponent.componentId === postInstallationComponentId || !postInstallationComponentId && !withEditorPostInstallationOverride));
};
export const getIsWixApp = appRuntimeData => appRuntimeData == null ? void 0 : appRuntimeData.wixApp;
export const getHasBlocksWithoutEnforcedPermissions = appRuntimeData => {
  var _appRuntimeData$appIn5;
  return (appRuntimeData == null || (_appRuntimeData$appIn5 = appRuntimeData.appInstallationData) == null ? void 0 : _appRuntimeData$appIn5.legacyBlocksConsent) || false;
};
export const getShowConsentBehaviour = appRuntimeData => {
  var _appRuntimeData$appIn6;
  return appRuntimeData == null || (_appRuntimeData$appIn6 = appRuntimeData.appInstallationData) == null || (_appRuntimeData$appIn6 = _appRuntimeData$appIn6.consentOptions) == null ? void 0 : _appRuntimeData$appIn6.showConsentBehaviour;
};
//# sourceMappingURL=appRuntimeReader.js.map